// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.create_dashboard__ycfn\\+ {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.create_dashboardContain__bGI8P {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.create_bodythemedark__Zhrdl .create_dashboardContain__bGI8P,
.create_bodythemedark__Zhrdl .create_dashboard__ycfn\\+,
.create_bodythemedark__Zhrdl .create_cont2__XjqMy {
  background-Color: #0f1824;
}

.create_top_header__IX9AE .create_top_header_inner__LnQeN {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.create_cont2__XjqMy {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.create_subLink__ilHZV svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.create_footer__zuxVk {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.create_bodythemelight__wK7Fm {
  background-color: #fff;
  padding-top: 90px;
}

.create_bodythemedark__Zhrdl {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.create_headerthemelight__vy5K3 {
  background-color: #fff;
}

.create_headerthemedark__w6SCh {
  background-color: #132337;
}

.create_top_header__IX9AE {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.create_menuthemelight__eJiEz {
  background-color: #fff;
}

.create_menuthemedark__E2kp3 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.create_menulinklight__oyAMk span {
  color: #666666 !important;
}

.create_menulinklight__oyAMk a {
  color: #CBCBCB !important;
}

.create_menulinklight__oyAMk:hover span, .create_menulinklight__oyAMk:hover a {
  color: #fff !important;
}

.create_menulinkdarkSelected__t9sjL {
  background-color: #1c2e45;
  color: #3b82f6;
}

.create_menuthemelight__eJiEz .create_menulinklightSelected__yKxxF {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.create_menulinkdark__OG2L- {
  color: #92afd3 !important;
}

.create_menulinklight__oyAMk:hover {
  color: #fff !important;
  background-color: #131F43;
}

.create_menulinklight__oyAMk .create_sub_arrow__Nb3Os svg path {
  stroke: #CBCBCB !important;
}

.create_menulinklight__oyAMk:hover .create_sub_arrow__Nb3Os svg path {
  stroke: #fff !important;
}

.create_menulinkdark__OG2L- .create_sub_arrow__Nb3Os svg path {
  stroke: #92afd3 !important;
}

.create_menulinkdark__OG2L-:hover .create_sub_arrow__Nb3Os svg path {
  stroke: #fff !important;
}

.create_menulinkdark__OG2L-:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.create_headinglight__uztFz {
  color: #60677e;
}

.create_headingdark__AFijb {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.create_searchboxlight__Djoqp {
  background-color: #fff;
  border: none;
}

.create_searchboxdark__hRBIh {
  background-color: #132337;
  color: #fff;
  border: none;
}

.create_searchboxdark__hRBIh::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.create_tableheadlight__v-1lY {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.create_tableheadlight__v-1lY th {
  color: #fff;
}

thead .create_tableheadlight__v-1lY th:first-child,
thead .create_tableheaddark__uOwkK th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .create_tableheadlight__v-1lY th:last-child,
thead .create_tableheaddark__uOwkK th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.create_table__UPH2Y.create_table-borderless__MPz49 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.create_tableheaddark__uOwkK {
  background-color: #132337;
  color: #fff;
}

.create_table-borderless__MPz49 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.create_table-borderless__MPz49 .create_left-section__w3fkY {
  padding-top: 10px;
}

.create_tablebodylight__cXeKe td,
.create_tablebodydark__XH\\+H3 td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.create_tablebodylight__cXeKe {
  background-color: #fff;
}
.create_tablebodylight__cXeKe:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.create_tablebodydark__XH\\+H3 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.create_tablebodydark__XH\\+H3:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.create_paginationlight__YE9T1 {
  color: #60677e !important;
  font-size: 13px !important;
}

.create_paginationdark__Z9QUD {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.create_formthemelight__-tQOc {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.create_formthemedark__8QLkz {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.create_formthemedark__8QLkz ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.create_viewformlight__UGAvj {
  background-color: #f3f6f9;
}

.create_permissionboxlight__DWgmy {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.create_permissionboxdark__i\\+uee {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.create_errormsgclr__XKJmk {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.create_graphclrlight__n1jf1 {
  background-color: #fff;
}

.create_graphclrdark__-96mQ {
  background-color: #132337;
}

/* 
Counter theme
*/
#create_card1bglight__2ykN6 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#create_card1bgdark__lJdKQ {
  background: #392f28;
}

#create_card2bglight__eFCtl {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#create_card2bgdark__\\+b3vd {
  background: #1c3238;
}

#create_card3bglight__tZmxz {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#create_card3bgdark__V1ma4 {
  background: #3a2434;
}

#create_card4bglight__1-H58 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#create_card4bgdark__26\\+vu {
  background: #2f264f;
}

#create_card1bgdark__lJdKQ a, #create_card1bgdark__lJdKQ p,
#create_card2bgdark__\\+b3vd a, #create_card2bgdark__\\+b3vd p,
#create_card3bgdark__V1ma4 a, #create_card3bgdark__V1ma4 p,
#create_card4bgdark__26\\+vu a, #create_card4bgdark__26\\+vu p {
  color: #fff;
}

/* 
Action button theme
*/
.create_actionbtnlight__FZ2Ip {
  color: rgba(70, 71, 91, 0.8705882353);
}

.create_actionbtnlight__FZ2Ip:hover {
  cursor: pointer;
}

.create_actionbtndark__mCRPq {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.create_profiledropdownlight__zaiQb {
  background-color: #fff;
}

.create_profiledropdowndark__LhjZV {
  background-color: #151521;
}

.create_settingsection__t6oXv #create_addform__7yXt7.create_formthemedark__8QLkz .create_savebtn__aHkIw {
  background-color: #3b82f6;
  color: #fff;
}

#create_addform__7yXt7.create_formthemedark__8QLkz .create_savebtn__aHkIw {
  background-color: #3b82f6;
  color: #fff;
}

.create_profile_conatiner__xyoEU {
  border-radius: 5px !important;
}

.create_bodythemedark__Zhrdl .create_ag-theme-alpine__E3DQ3 .create_ag-row__Fdbw- {
  background: #000 !important;
}

.create_bodythemedark__Zhrdl .create_formbtn__P3Pqp {
  background-color: #3b82f6;
}

.create_bodythemedark__Zhrdl .create_formbtn__P3Pqp:hover {
  background-color: #2563eb;
}

.create_bodythemedark__Zhrdl .create_resetbtn__CPTof {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.create_bodythemedark__Zhrdl .create_resetbtn__CPTof:hover {
  background-color: #3b82f6;
}

.create_headingdark__AFijb span {
  background-color: #132337;
}

.create_resetbtn__CPTof {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.create_resetbtn__CPTof:hover,
.create_resetbtn__CPTof:active,
.create_resetbtn__CPTof:focus {
  background-color: #131F43;
  color: #fff;
}

.create_addBtn__s2gCR {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.create_addbtnlight__ZshVS {
  background-color: #38A169;
}

.create_addbtndark__g3cNt {
  background-color: #3b82f6;
}

.create_addbtndark__g3cNt:hover {
  background-color: #2563eb;
}

.create_formthemedark__8QLkz label {
  color: #92afd3;
}

.create_addBtn__s2gCR svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.create_addBtn__s2gCR:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.create_cust_addBtn__w1Qa5.create_addBtn__s2gCR svg {
  top: 2px;
}

.create_deleteBtn__K6LJW {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.create_deleteBtn__K6LJW {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.create_deleteBtn__K6LJW:active, .create_deleteBtn__K6LJW:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.create_deleteBtn__K6LJW svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.create_deleteBtn__K6LJW:hover,
.create_deleteBtn__K6LJW:active,
.create_deleteBtn__K6LJW:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.create_confirmBtn__ByMwZ {
  background-color: #131F43;
}

.create_confirmBtn__ByMwZ:hover,
.create_confirmBtn__ByMwZ:active,
.create_confirmBtn__ByMwZ:focus {
  background-color: #131F43;
}

.create_confirmBtn__ByMwZ svg {
  top: 0;
}

.create_delPopContainer__Rf0Tg .create_modal-body__6n3Ov {
  padding: 25px;
  text-align: center;
}

.create_delPopContainer__Rf0Tg .create_delet_icon__uR\\+g5 {
  margin-bottom: 11px;
}

.create_delPopContainer__Rf0Tg p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.create_arrowback__od8Qh svg {
  fill: #000;
}

.create_bodythemedark__Zhrdl .create_arrowback__od8Qh {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.create_bodythemedark__Zhrdl .create_arrowback__od8Qh svg {
  fill: #3b82f6;
}

.create_bodythemedark__Zhrdl .create_drpdwn_btn__hLVDY {
  background-color: #132337;
}

.create_bodythemedark__Zhrdl .create_empname__OMJdz {
  color: #92afd3 !important;
}

.create_bodythemedark__Zhrdl .create_navitemli__Hx0gs a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.create_bodythemedark__Zhrdl .create_tabnavli__VlO4y a.create_settingsgeneral__dUF7B,
.create_bodythemedark__Zhrdl .create_tabnavli__VlO4y a.create_settingslinks__Iit5q:hover {
  background-color: #3b82f6;
  color: #fff;
}

.create_bodythemedark__Zhrdl .create_tabnavli__VlO4y a.create_settingslinks__Iit5q {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.create_headerthemedark__w6SCh .create_dropdown_menu_contain__PBq89 {
  background-color: #1c2e45;
  color: #fff;
}

.create_headerthemedark__w6SCh .create_dropdown_menu_contain__PBq89 ul li a,
.create_headerthemedark__w6SCh .create_dropdown_menu_contain__PBq89 .create_dropdown_item__5w5f-,
.create_headerthemedark__w6SCh .create_dropdown_menu_contain__PBq89 .create_dropdown_item__5w5f- h5 {
  color: #fff;
}

.create_headerthemedark__w6SCh .create_dropdown_menu_contain__PBq89 ul li a:hover,
.create_headerthemedark__w6SCh .create_dropdown_menu_contain__PBq89 .create_dropdown_item__5w5f-:hover {
  background-color: #132337;
  color: #fff;
}

.create_dropdown_item__5w5f-:active {
  background-color: #F5F6FA;
}

.create_profile_arrrow_dwn__cXJGQ {
  stroke: #132337;
}

.create_headerthemedark__w6SCh .create_profile_arrrow_dwn__cXJGQ {
  stroke: #fff;
}

.create_dateinputbox1__PS2oL input,
.create_dateinputbox1__PS2oL span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .create_tableheadlight__v-1lY th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .create_dashboard__ycfn\\+ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .create_cont2__XjqMy {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .create_sectionright__EAzBp {
    float: unset !important;
  }
  .create_dashboard__ycfn\\+ {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .create_cont2__XjqMy {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .create_bodythemelight__wK7Fm, .create_bodythemedark__Zhrdl {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .create_exer_modal_contain__rAEFB .create_modal-dialog__n0UGn {
    max-width: 1055px;
  }
  .create_delPopContainer__Rf0Tg .create_modal-dialog__n0UGn {
    max-width: 350px;
  }
}
#create_addform__7yXt7 {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 40px;
}
#create_addform__7yXt7 .create_permission_title__0RPDX {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
#create_addform__7yXt7 #create_addheading__Pt2AU {
  font-size: 14px;
  margin-bottom: 0px;
  margin-left: 5px;
}
#create_addform__7yXt7 .create_inputbox__02NFB {
  padding: 5px 5px 8px 10px;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#create_addform__7yXt7 .create_inputbox1__ggdTF {
  padding: 5px 5px 8px 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#create_addform__7yXt7 .create_formbtn__P3Pqp {
  background-color: #131F43;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
  margin-bottom: 10px;
  float: left;
}
#create_addform__7yXt7 .create_formbtn__P3Pqp:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#create_addform__7yXt7 .create_resetbtn__CPTof {
  margin-left: 10px;
  background-color: rgba(180, 184, 192, 0.3882352941);
  border: none;
  color: #212529;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#create_addform__7yXt7 .create_resetbtn__CPTof:hover {
  background-color: #dde2eb;
}
#create_addform__7yXt7 ::placeholder {
  font-size: 12px;
}
#create_addform__7yXt7 ul {
  padding-left: 0px;
  display: flex;
  margin-bottom: 0;
}
#create_addform__7yXt7 ul li {
  list-style: none;
  width: 150px;
}
#create_addform__7yXt7 .create_selectlabel__138mq {
  margin-left: 5px;
  font-size: 14px;
  text-transform: capitalize;
  vertical-align: middle;
}
#create_addform__7yXt7 #create_permissionbox__GRwRF {
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}
#create_addform__7yXt7 .create_arrowback__od8Qh {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#create_addform__7yXt7 .create_arrowback__od8Qh:hover {
  background-color: #39979d;
  color: #fff;
}

.create_formthemedark__8QLkz label {
  color: #92afd3 !important;
}

.create_formthemedark__8QLkz input[type=checkbox i] {
  accent-color: #3b82f6 !important;
}

@media only screen and (max-width: 878px) {
  #create_addform__7yXt7 ul {
    display: list-item !important;
    list-style: none;
  }
}
@media only screen and (max-width: 600px) {
  #create_dashboardcont2__P0\\+bX {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/create.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AAzsBA;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA0sBJ;AAxsBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA0sBR;AAvsBI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AAysBR;AAtsBI;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cDsCM;ECrCN,eAAA;AAwsBR;AAtsBI;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDmBc;EClBd,WD4BM;AC4qBd;AArsBI;EACI,yBDqCW;ECpCX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAusBR;AArsBY;EACI,2CD2BK;AC4qBrB;AApsBI;EACI,iBAAA;EACA,mDAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAssBR;AAnsBI;EACI,yBAAA;AAqsBR;AAlsBI;EACI,eAAA;AAosBR;AAjsBI;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;AAmsBN;AAlsBQ;EACI,gBAAA;EACA,YAAA;AAosBZ;AAhsBI;EACI,gBAAA;EAEA,eAAA;EACA,0BAAA;EACA,sBAAA;AAisBR;AA9rBI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAgsBR;AA7rBI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA+rBR;AA7rBU;EACE,yBAAA;EACA,WAAA;AA+rBZ;;AAxrBE;EACE,yBAAA;AA2rBJ;;AAxrBI;EACI,gCAAA;AA2rBR;;AAvrBE;EAEM;IACI,6BAAA;IACA,gBAAA;EAyrBV;AACF;AAnrBE;EACE;IACI,wBD1CI;IC2CJ,UD1CG;IC2CH,kBAAA;IACA,aDlDW;ECuuBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    margin-bottom: 40px;\n\n    .permission_title{\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n    }\n\n    #addheading{\n        font-size: 14px;\n        margin-bottom: 0px;\n        margin-left: 5px;\n    }\n\n    .inputbox{\n        padding: 5px 5px 8px 10px;\n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .inputbox1{\n        padding: 5px 5px 8px 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;         \n    }\n\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n        margin-bottom: 10px;\n        float: left;\n\n            &:hover{\n                background-color: $secondary-btncolor;\n            }\n    }\n    .resetbtn{\n        margin-left: 10px;\n        background-color: #b4b8c063;\n        border: none; \n        color: #212529;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n    }\n\n    .resetbtn:hover{\n        background-color: #dde2eb; \n    }\n\n    ::placeholder{\n        font-size: 12px;\n    }\n\n    ul{\n      padding-left: 0px;\n      display: flex;\n      margin-bottom: 0;\n        li{\n            list-style: none;\n            width: 150px;\n        }\n    } \n\n    .selectlabel{\n        margin-left: 5px;\n         \n        font-size: 14px;\n        text-transform: capitalize;\n        vertical-align: middle;\n    }\n\n    #permissionbox{\n        padding: 10px;\n        margin-bottom: 20px;\n        border-radius: 5px;\n    }\n\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n\n\n  }\n\n  .formthemedark label {\n    color: $dark-light-blue !important;\n  }\n\n    .formthemedark input[type='checkbox' i] {\n        accent-color: $dark-active-blue !important;\n    }\n\n\n  @media only screen and (max-width: 878px) {\n    #addform{\n        ul {\n            display: list-item !important;\n            list-style: none;\n        }\n    }\n  }\n  \n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `create_dashboard__ycfn+`,
	"dashboardContain": `create_dashboardContain__bGI8P`,
	"bodythemedark": `create_bodythemedark__Zhrdl`,
	"cont2": `create_cont2__XjqMy`,
	"top_header": `create_top_header__IX9AE`,
	"top_header_inner": `create_top_header_inner__LnQeN`,
	"subLink": `create_subLink__ilHZV`,
	"footer": `create_footer__zuxVk`,
	"bodythemelight": `create_bodythemelight__wK7Fm`,
	"headerthemelight": `create_headerthemelight__vy5K3`,
	"headerthemedark": `create_headerthemedark__w6SCh`,
	"menuthemelight": `create_menuthemelight__eJiEz`,
	"menuthemedark": `create_menuthemedark__E2kp3`,
	"menulinklight": `create_menulinklight__oyAMk`,
	"menulinkdarkSelected": `create_menulinkdarkSelected__t9sjL`,
	"menulinklightSelected": `create_menulinklightSelected__yKxxF`,
	"menulinkdark": `create_menulinkdark__OG2L-`,
	"sub_arrow": `create_sub_arrow__Nb3Os`,
	"headinglight": `create_headinglight__uztFz`,
	"headingdark": `create_headingdark__AFijb`,
	"searchboxlight": `create_searchboxlight__Djoqp`,
	"searchboxdark": `create_searchboxdark__hRBIh`,
	"tableheadlight": `create_tableheadlight__v-1lY`,
	"tableheaddark": `create_tableheaddark__uOwkK`,
	"table": `create_table__UPH2Y`,
	"table-borderless": `create_table-borderless__MPz49`,
	"left-section": `create_left-section__w3fkY`,
	"tablebodylight": `create_tablebodylight__cXeKe`,
	"tablebodydark": `create_tablebodydark__XH+H3`,
	"paginationlight": `create_paginationlight__YE9T1`,
	"paginationdark": `create_paginationdark__Z9QUD`,
	"formthemelight": `create_formthemelight__-tQOc`,
	"formthemedark": `create_formthemedark__8QLkz`,
	"viewformlight": `create_viewformlight__UGAvj`,
	"permissionboxlight": `create_permissionboxlight__DWgmy`,
	"permissionboxdark": `create_permissionboxdark__i+uee`,
	"errormsgclr": `create_errormsgclr__XKJmk`,
	"graphclrlight": `create_graphclrlight__n1jf1`,
	"graphclrdark": `create_graphclrdark__-96mQ`,
	"card1bglight": `create_card1bglight__2ykN6`,
	"card1bgdark": `create_card1bgdark__lJdKQ`,
	"card2bglight": `create_card2bglight__eFCtl`,
	"card2bgdark": `create_card2bgdark__+b3vd`,
	"card3bglight": `create_card3bglight__tZmxz`,
	"card3bgdark": `create_card3bgdark__V1ma4`,
	"card4bglight": `create_card4bglight__1-H58`,
	"card4bgdark": `create_card4bgdark__26+vu`,
	"actionbtnlight": `create_actionbtnlight__FZ2Ip`,
	"actionbtndark": `create_actionbtndark__mCRPq`,
	"profiledropdownlight": `create_profiledropdownlight__zaiQb`,
	"profiledropdowndark": `create_profiledropdowndark__LhjZV`,
	"settingsection": `create_settingsection__t6oXv`,
	"addform": `create_addform__7yXt7`,
	"savebtn": `create_savebtn__aHkIw`,
	"profile_conatiner": `create_profile_conatiner__xyoEU`,
	"ag-theme-alpine": `create_ag-theme-alpine__E3DQ3`,
	"ag-row": `create_ag-row__Fdbw-`,
	"formbtn": `create_formbtn__P3Pqp`,
	"resetbtn": `create_resetbtn__CPTof`,
	"addBtn": `create_addBtn__s2gCR`,
	"addbtnlight": `create_addbtnlight__ZshVS`,
	"addbtndark": `create_addbtndark__g3cNt`,
	"cust_addBtn": `create_cust_addBtn__w1Qa5`,
	"deleteBtn": `create_deleteBtn__K6LJW`,
	"confirmBtn": `create_confirmBtn__ByMwZ`,
	"delPopContainer": `create_delPopContainer__Rf0Tg`,
	"modal-body": `create_modal-body__6n3Ov`,
	"delet_icon": `create_delet_icon__uR+g5`,
	"arrowback": `create_arrowback__od8Qh`,
	"drpdwn_btn": `create_drpdwn_btn__hLVDY`,
	"empname": `create_empname__OMJdz`,
	"navitemli": `create_navitemli__Hx0gs`,
	"tabnavli": `create_tabnavli__VlO4y`,
	"settingsgeneral": `create_settingsgeneral__dUF7B`,
	"settingslinks": `create_settingslinks__Iit5q`,
	"dropdown_menu_contain": `create_dropdown_menu_contain__PBq89`,
	"dropdown_item": `create_dropdown_item__5w5f-`,
	"profile_arrrow_dwn": `create_profile_arrrow_dwn__cXJGQ`,
	"dateinputbox1": `create_dateinputbox1__PS2oL`,
	"sectionright": `create_sectionright__EAzBp`,
	"exer_modal_contain": `create_exer_modal_contain__rAEFB`,
	"modal-dialog": `create_modal-dialog__n0UGn`,
	"permission_title": `create_permission_title__0RPDX`,
	"addheading": `create_addheading__Pt2AU`,
	"inputbox": `create_inputbox__02NFB`,
	"inputbox1": `create_inputbox1__ggdTF`,
	"selectlabel": `create_selectlabel__138mq`,
	"permissionbox": `create_permissionbox__GRwRF`,
	"dashboardcont2": `create_dashboardcont2__P0+bX`
};
export default ___CSS_LOADER_EXPORT___;
